/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fun_Such_Shrimp_DripInputs */

const fr_fun_such_shrimp_drip = /** @type {(inputs: Fun_Such_Shrimp_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des inscrits`)
};

/**

* @param {Fun_Such_Shrimp_DripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fun_such_shrimp_drip = /** @type {((inputs?: Fun_Such_Shrimp_DripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fun_Such_Shrimp_DripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fun_such_shrimp_drip(inputs)
});